var React = require('react');

function UserClock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M496 224a144 144 0 1 0 144 144 143.91 143.91 0 0 0-144-144zm64 150.3a9.77 9.77 0 0 1-9.7 9.7h-60.6a9.77 9.77 0 0 1-9.7-9.7v-76.6a9.77 9.77 0 0 1 9.7-9.7h12.6a9.77 9.77 0 0 1 9.7 9.7V352h38.3a9.77 9.77 0 0 1 9.7 9.7z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 112a175.38 175.38 0 0 1 18.2-77.5 133.25 133.25 0 0 0-24.6-2.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144z","className":"fa-primary","key":2})]);
}

UserClock.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = UserClock;

UserClock.default = UserClock;
